// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button:hover svg[data-v-13817edc] {\n  opacity: 1 !important;\n}", ""]);
// Exports
module.exports = exports;
